import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const { t } = useTranslation();

  const formatViews = (views: number): string => {
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
      data-product-shop
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={comic.title}
        />
        <div className="absolute top-2 left-2">
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-medium ${
              comic.status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>
        {comic.rating >= 9.5 && (
          <div className="absolute top-2 right-2 px-1.5 py-0.5 rounded bg-accent-500 text-background-50 text-xs font-bold">
            HOT
          </div>
        )}
      </div>

      <div className="p-3">
        <h3 className="font-heading text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1 text-accent-500">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-xs"></i>
            </div>
            <span className="text-xs font-semibold">{comic.rating}</span>
          </div>
          <span className="text-xs text-foreground-500">
            {formatViews(comic.views)} {t('comic.views')}
          </span>
        </div>
      </div>
    </Link>
  );
}